export const DASHBOARD = {
  navy: "#061D36",
  navyMid: "#0f2c4a",
  navyBtn: "#1a3a5c",
  blue: "#1565C0",
  blueDark: "#0d47a1",
  title: "#0f2c4a",
  body: "#5a6b85",
};

export const headerIconGradient = `linear-gradient(135deg, ${DASHBOARD.blue}, ${DASHBOARD.blueDark})`;
export const sectionHeaderGradient = `linear-gradient(135deg, ${DASHBOARD.navyMid}, ${DASHBOARD.blue})`;

export const accentBtnSx = {
  borderRadius: "8px",
  fontWeight: 600,
  boxShadow: "0 4px 12px rgba(21, 101, 192, 0.25) !important",
  "&:hover": {
    boxShadow: "0 6px 16px rgba(21, 101, 192, 0.3) !important",
  },
  "&:focus, &:focus:not(:hover), &.Mui-focusVisible": {
    outline: "none",
    boxShadow: "0 4px 12px rgba(21, 101, 192, 0.25) !important",
  },
};
